export const LISTAR_URAS = 'LISTAR_URAS'
export const LISTAR_AUDIOS = 'LISTAR_AUDIOS'
export const LISTAR_CENTRO_DE_CUSTOS = 'LISTAR_CENTRO_DE_CUSTOS'
export const LISTAR_ROTAS = 'LISTAR_ROTAS'
export const LISTAR_GRUPOS_ATENDIMENTO = 'LISTAR_GRUPOS_ATENDIMENTO'
export const LISTAR_TRONCOS = 'LISTAR_TRONCOS'
export const LISTAR_FILAS = 'LIASTAR_FILAS'
export const LISTAR_WEBHOOKS = 'LISTAR_WEBHOOKS'
export const LISTAR_REGEXES = 'LISTAR_REGEXES'
export const LISTAR_CONFERENCIAS = 'LISTAR_CONFERENCIAS'
export const LISTAR_MUSICAS_EM_ESPERA = 'LISTAR_MUSICAS_EM_ESPERA'
export const LISTAR_AVALIACOES_ATENDIMENTO = 'LISTAR_AVALIACOES_ATENDIMENTO'
export const LISTAR_TAGS = 'LISTAR_TAGS'
